import { Component, Input, OnInit } from '@angular/core';
import { Banner, BannerImage, BannerSponsoring, StoryblokBannerImage } from '../../models';
import { BANNER_VIEWPORTS } from '../../constants/banner-viewports.constants';
import { HIGH_QUALITY_FILTER } from '~app/modules/storyblok/constants';
import { FeatureToggleEnum, NUMBER_0 } from '~shared/constants';
import { Observable } from 'rxjs';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';

@Component({
  selector: 'app-banner-image-wrapper',
  templateUrl: './banner-image-wrapper.component.html',
})
export class BannerImageWrapperComponent implements OnInit {
  @Input() _uid: string;
  @Input() title: string;
  @Input() banners: StoryblokBannerImage;
  @Input() bannerLink: string;
  @Input() isExternalLink: boolean = false;
  @Input() trackingName: string;
  @Input() set sponsor(value: Array<BannerSponsoring>) {
    this._sponsorItem = value?.[NUMBER_0];
  }

  private _sponsorItem: BannerSponsoring;

  bannerImages: BannerImage[] = [];
  isSponsoringEnabled$: Observable<boolean> = this.featureFlagService.isFeatureEnabled(
    FeatureToggleEnum.FF_MACO_SPONSORING_WIDGET
  );

  get sponsorItem(): BannerSponsoring {
    return this._sponsorItem;
  }

  constructor(private featureFlagService: ActiveFeaturesConfigcatService) {}

  ngOnInit(): void {
    this.buildBannerImages();
  }

  buildBannerImages(): void {
    const allBanner = this.findAllBanner();

    if (allBanner) {
      this.bannerImages = this.buildBannersFromAll(allBanner);
      return;
    }
    this.bannerImages = this.buildSpecificBanners();
  }

  findAllBanner(): Banner {
    return this.banners.banners.find((banner) => banner.device === 'all');
  }

  buildBannersFromAll(allBanner: Banner): BannerImage[] {
    return BANNER_VIEWPORTS.map((bannerViewport) => {
      return {
        url: `${allBanner.url}/m/${bannerViewport.dimension}/${HIGH_QUALITY_FILTER}`,
        viewport: bannerViewport.viewport,
      };
    });
  }

  buildSpecificBanners(): BannerImage[] {
    return this.banners.banners.map((storyblokBanner) => {
      const bannerViewport = BANNER_VIEWPORTS.find((banner) => banner.device === storyblokBanner.device);
      return {
        url: `${storyblokBanner.url}/m/${HIGH_QUALITY_FILTER}`,
        viewport: bannerViewport.viewport,
      };
    });
  }
}
